import React, { useEffect, useState, useRef, Fragment } from 'react'
import { isMobile, isTablet, deviceDetect } from "react-device-detect";
import Slider from "react-slick";
import { css } from 'emotion'

import Constants, { htmlWidget, LargeBusiness } from '../../Constants';

import Dom from '../../utils/Dom'
import EirButton from '../eir-button/EirButton';

const RtceSlides = (props) => {
    Dom.addStyleSheet(Constants.externalCss.slickCarousel.minified);
    Dom.addStyleSheet(Constants.externalCss.slickCarousel.themeMinified);

    const [copy, setCopy] = useState('')
    const [md] = useState(window.outerWidth > 960 && window.outerWidth < 1280)

    const sliderRef = useRef(null);
    const playButton = useRef(null);
    const pauseButton = useRef(null);
    const userPausedRef = useRef(false);

    const renderContent = (content) => {
        return { __html: content };
    }

    const togglePlay = () => {        // ⭐ NEW
        if (!sliderRef.current) return;

        if (pauseButton.current.style.display === 'none') {
            playButton.current.style.display = 'none';
            playButton.current.tabIndex = -1;
            pauseButton.current.style.display = 'flex';
            pauseButton.current.tabIndex = 0;
            sliderRef.current.slickPlay();
            sliderRef.current.innerSlider.autoplay = true; // keep autoplay when playing
            userPausedRef.current = false;
          } else {
            pauseButton.current.style.display = 'none';
            pauseButton.current.tabIndex = -1;
            playButton.current.style.display = 'flex';
            playButton.current.tabIndex = 0;
            sliderRef.current.slickPause();
            sliderRef.current.innerSlider.autoplay = false; // keep autoplay when playing
            userPausedRef.current = true;
          }        
      };

      const handleKeyPress = (e) => {
        if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') {
          e.preventDefault(); // prevent page scroll on space
          togglePlay();
        }
      };
      
    const desktopAuto = props.slides.eirRtceTile.length > 4;
    const tabletAuto  = props.slides.eirRtceTile.length > 2;
    const mobileAuto  = props.slides.eirRtceTile.length > 1;

    // Function to get aria-label for pagination dots
    // Reusable function to generate accessible pagination dot settings
    const buildAccessibleDots = (autoplayFlag) => ({
        customPaging: (i) => (
        <button type="button" aria-label={`Go to slide ${i + 1}`} />
        ),
    
        appendDots: (dots) => (
        <div className="rtce-dots-wrapper">
            <div className="rtce-dots-inner">
              <ul className="rtce-dots">
                {React.Children.map(dots, (dot, idx) => {
                  const isActive = dot.props.className.includes("slick-active");
                  return React.cloneElement(dot, {
                    children: React.cloneElement(dot.props.children, {
                      "aria-label": isActive
                        ? `Slide ${idx + 1}`
                        : `Go to slide ${idx + 1}`,
                      "aria-current": isActive ? "true" : null
                    })
                  });
                })}
              </ul>
          
             {autoplayFlag && (
                <div className="rtce-controls">
                    <button 
                        ref={pauseButton} 
                        className='pause-button'
                        aria-label="Pause" 
                        onClick={togglePlay}
                        onKeyDown={handleKeyPress}
                        // onKeyUp={handleKeyUp}
                        tabIndex={0}
                        >
                        <span className="icon pause" aria-hidden="true" style={{'--pseudo-active-color': '#493553'}} />
                    </button>
                    <button 
                        ref={playButton} 
                        aria-label="Play" 
                        // aria-pressed="false" 
                        className='play-button'  
                        onClick={togglePlay} 
                        onKeyDown={handleKeyPress}
                        // onKeyUp={handleKeyUp}
                        style={{ display: 'none' }}
                        tabIndex={-1}
                        >
                        <span className="icon" aria-hidden="true" style={{'--pseudo-active-color': '#493553'}}/>
                    </button>
                </div>
             )}
           </div>
        </div>
        )
    });

    function LeftCustomArrow(props) {
        const { className, style, onClick } = props;
        return (
            <div
                className={className}
                style={{ ...style }}
                onClick={onClick}
                aria-label="Move to next slide"
                role="button"
                tabIndex={0}                
                onKeyDown={(e) => {
                    if (e.key === "Enter" || e.key === " ") {
                    e.preventDefault();
                    onClick();
                    }
                }}
            />
        );
    }
    function RightCustomArrow(props) {
        const { className, style, onClick } = props;
        return (
            <div
                className={className}
                style={{ ...style }}
                onClick={onClick}
                aria-label="Move to previous slide"
                role="button"
                tabIndex={0}
                onKeyDown={(e) => {
                    if (e.key === "Enter" || e.key === " ") {
                    e.preventDefault();
                    onClick();
                    }
                }}
            >
            </div>
        );
    }
    function MobileLeftCustomArrow(props) {
        const { className, style, onClick } = props;
        return (
            <div
                className={className}
                style={{ ...style }}
                onClick={onClick}
                aria-label="Move to next slide"
                role="button"
                tabIndex={0}
                onKeyDown={(e) => {
                    if (e.key === "Enter" || e.key === " ") {
                    e.preventDefault();
                    onClick();
                    }
                }}
            />
        );
    }
    function MobileRightCustomArrow(props) {
        const { className, style, onClick } = props;
        return (
            <div
                className={className}
                style={{ ...style, zIndex: "1000" }}
                onClick={onClick}
                aria-label="Move to previous slide"
                role="button"
                tabIndex={0}
                onKeyDown={(e) => {
                    if (e.key === "Enter" || e.key === " ") {
                    e.preventDefault();
                    onClick();
                    }
                }}
            >
            </div>
        );
    }

    const tabletSettingsModules = {
        infinite: props.slides.eirRtceTile.length > 2 ? true : false,
        dots: LargeBusiness.isLBSite ? false : true,
        slidesToShow: md ? 3 : 2,
        slidesToScroll: md ? 3 : 2,
        arrows: props.slides.eirRtceTile.length > 2 ? true : false,
        autoplay: props.slides.eirRtceTile.length > 2 ? true : false,
        autoplaySpeed: 5000,
        nextArrow: <MobileLeftCustomArrow />,
        prevArrow: <MobileRightCustomArrow />,               
        pauseOnFocus: true,
        pauseOnHover: true,
        pauseOnDotsHover: true,
        // accessibility: true,
        focusOnChange: false,
        afterChange: () => { setTimeout(fixClonesAccessibility, 50)},
        onInit: () => { setTimeout(fixClonesAccessibility, 50)},
        ...buildAccessibleDots(tabletAuto)
    };

    const mobileSettingsModules = {
        infinite: props.slides.eirRtceTile.length > 1 ? true : false,
        dots: LargeBusiness.isLBSite ? false : true,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: props.slides.eirRtceTile.length > 1 ? true : false,
        autoplay: props.slides.eirRtceTile.length > 1 ? true : false,
        autoplaySpeed: 5000,
        nextArrow: <MobileLeftCustomArrow style={{ visibility: "visible" }} />,
        prevArrow: <MobileRightCustomArrow style={{ visibility: "visible" }} />,
        pauseOnFocus: true,
        pauseOnHover: true,
        pauseOnDotsHover: true,
        // accessibility: true,
        focusOnChange: false,
        afterChange: () => { setTimeout(fixClonesAccessibility, 50)},
        onInit: () => { setTimeout(fixClonesAccessibility, 50)},
        ...buildAccessibleDots(mobileAuto)
    };

    const settingsModules = {
        infinite: props.slides.eirRtceTile.length > 4 ? true : false,
        dots: LargeBusiness.isLBSite ? false : true,
        slidesToShow: 4,
        slidesToScroll: 4,
        arrows: props.slides.eirRtceTile.length > 4 ? true : false,
        autoplay: props.slides.eirRtceTile.length > 4 ? true : false,
        autoplaySpeed: 5000,
        nextArrow: <LeftCustomArrow />,
        prevArrow: <RightCustomArrow />,
        pauseOnFocus: true,
        pauseOnHover: true,
        pauseOnDotsHover: true,
        // accessibility: true,
        focusOnChange: false,
        afterChange: () => { setTimeout(fixClonesAccessibility, 50)},
        onInit: () => { setTimeout(fixClonesAccessibility, 50)},
          
        ...buildAccessibleDots(desktopAuto)
    };

    useEffect(() => {
        let getParentRef = document.querySelector("#rtce-ctr-" + props.slides.occurence);
        let getArrows = getParentRef.querySelectorAll(".rtce-main .slick-arrow");

        // variable image heights in rtce tiles

        //     let getImages = getParentRef.querySelectorAll(`.rtce-tile-image img`)
        //     var imgHeights = [];
        //     // getImages[0].onload = (x) => {console.log("onload x",x.target.clientHeight)}
        //     for (var i= 0; i < getImages.length; i++){
        //         getImages[i].onload = (x) => {
        //             imgHeights.push(x.target.clientHeight);
        //         }        
        //     }

        // setTimeout(()=>{

        //     const  maxHeight = Math.max.apply(Math , imgHeights);

        //     const heightTop = (maxHeight/2);
        //     if(getArrows != null && getArrows != undefined){
        //         getArrows[0].style = `top:${heightTop}px !important`
        //         getArrows[1].style = `top:${heightTop}px !important`
        //     }
        //     console.log("maxHeight,heighttop",maxHeight,heightTop,getArrows)

        // },3000)

        //fixed image heights in rtce tiles
        let getImage = getParentRef.querySelector(`.rtce-tile-image img`)
        let imageHeight = 0;
        if (getImage != null && getImage != undefined) {
            getImage.onload = (e) => {
                imageHeight = (e.target.clientHeight);
                if (getArrows != null && getArrows != undefined) {
                    getArrows[0].style = `top:${10 + (imageHeight / 2)}px !important`
                    getArrows[1].style = `top:${10 + (imageHeight / 2)}px !important`
                }
            }
        }
        for (var cnt = 0; cnt < getArrows.length; cnt++) {
            // if (getArrows[cnt].classList.contains("slick-prev")) {
            //     getArrows[cnt].setAttribute("id", "rtce-carousel_arrow_prev");
            //     getArrows[cnt].setAttribute("title", "Previous");
                // var tmpBtn = document.createElement("button");
                // tmpBtn.title = "Prev";
                // tmpBtn.addEventListener("focus", function () {
                //     tmpBtn.parentNode.focus();
                // })
                // getArrows[cnt].appendChild(tmpBtn);
                // tmpBtn.addEventListener("click", function () {
                //     tmpBtn.blur();
                // })
            // }
            // else {
                // getArrows[cnt].setAttribute("id", "rtce-carousel_arrow_next");
                // getArrows[cnt].setAttribute("title", "Next");
                // var tmpBtn = document.createElement("button");
                // tmpBtn.title = "Next";
                // tmpBtn.addEventListener("focus", function () {
                //     tmpBtn.parentNode.focus();
                // })
                // getArrows[cnt].appendChild(tmpBtn);
                // tmpBtn.addEventListener("click", function () {
                //     tmpBtn.blur();
                // })

            // }
        }

        if (props.slides.eirRtceTile[0].tileCTA !== undefined) {
            setTimeout(() => {
                var tiles = getParentRef.querySelectorAll(".rtce-tile-copy");
                var firstRowTiles = [];

                for (var i = 0; i < tiles.length; i++) {
                    firstRowTiles.push(parseInt(tiles[i].clientHeight));
                }
                for (var i = 0; i < tiles.length; i++) {
                    tiles[i].style.height = (Math.max.apply(Math, firstRowTiles) + "px");
                }
            }, 5000);
        }

        //Logic to display same height for all the tile-titles in a row 
        if (props.slides.eirRtceTile[0].tileTitle !== undefined) {
            setTimeout(() => {
                var title = getParentRef.querySelectorAll(".tile-title");
                var firstRowTitles = [];

                for (var i = 0; i < title.length; i++) {
                    firstRowTitles.push(parseInt(title[i].clientHeight));
                }
                for (var i = 0; i < title.length; i++) {
                    title[i].style.height = (Math.max.apply(Math, firstRowTitles) + "px");
                }
            }, 5000);
        }

        //Logic to display same height for all the tile-subtitles in a row 
        if (props.slides.eirRtceTile[0].tileSubtitle !== undefined) {
            setTimeout(() => {
                var subtitle = getParentRef.querySelectorAll(".tile-subtitle");
                var firstRowSubTitles = [];

                for (var i = 0; i < subtitle.length; i++) {
                    firstRowSubTitles.push(parseInt(subtitle[i].clientHeight));
                }
                for (var i = 0; i < subtitle.length; i++) {
                    //  Adding hidden to the classlist if there is no subtitle in all the tiles.
                    if (Math.max(...firstRowSubTitles) == 8) {
                        subtitle[i].classList.add("hidden");
                    }
                    else {
                        subtitle[i].style.height = (Math.max.apply(Math, firstRowSubTitles) + "px");
                    }
                }
            }, 5000);
        }

        if (props.slides.eirRtceTile[0].tileTitleMobile == '' && props.slides.eirRtceTile[0].tileSubTitleMobile == '') {
            setCopy('no-copy')
        }



    })
          
    const fixClonesAccessibility = () => {
        if (!sliderRef.current) return;
      
        const container = sliderRef.current.innerSlider.list;
        const clones = container.querySelectorAll('.slick-cloned');
      
        clones.forEach((slide) => {
          slide.setAttribute('aria-hidden', 'true');
          slide.setAttribute('tabindex', '-1');
      
          slide.querySelectorAll('a, button, input, textarea, select').forEach((el) => {
            el.setAttribute('tabindex', '-1');
            el.setAttribute('aria-hidden', 'true');
          });
        });
      };

    //handles onclick event for rtce-tiles.
    const handleTileClicked = (tile) => {
        if (tile.tileRedirectionLink !== undefined) {
            tile.tileRedirectionLink !== "" ? window.open(tile.tileRedirectionLink, "_self") : ""
        }
    }

    const slides = props.slides.eirRtceTile.map((tile, i) =>
        <div key={i} className='tiles-main'>
            {
                <div className={!isMobile ? "rtce-tiles" : isTablet ? "rtce-tiles" : ''} onClick={() => handleTileClicked(tile)}>
                    <div className={'tile-inner d-flex flex-column justify-content-center'}>
                        {/* image */}
                        <div className='rtce-tile-image d-flex justify-content-center align-items-center' style={(tile.tileCTA != undefined || tile.tileTitle == '') ? { marginBottom: "15px" } : {}}>
                            {
                                tile.tileImage.path !== undefined && (tile.tileImage.path.indexOf(".svg") > 0 ?
                                    <object className='w-100 h-auto tile-image tile-image-svg' data={tile.tileImage.path} type={"image/svg+xml"} />
                                    :
                                    <img className='w-100 h-auto tile-image' src={tile.tileImage.path} alt={tile.altText } />
                                )
                            }

                        </div>
                        {/* content */}
                        {(tile.tileTitle !== '') &&
                            <div className={'rtce-tile-copy w-100'}>
                                <div className={'tile-title ' + htmlWidget + ((props.slides.eirRtceTile.length === 3 || props.slides.eirRtceTile.length === 2) ? 'three-tile-rtce-copy' : 'rtce-copy')} dangerouslySetInnerHTML={renderContent(tile.tileTitle)}></div>
                                {tile.tileSubtitle !== '' &&
                                    <div className={'pt-1 pb-1 tile-subtitle ' + htmlWidget + ((props.slides.eirRtceTile.length === 3 || props.slides.eirRtceTile.length === 2) ? 'three-tile-rtce-copy' : 'rtce-copy')} dangerouslySetInnerHTML={renderContent(tile.tileSubtitle)}></div>
                                }
                                {tile.tileSubcopy !== '' &&
                                    <div className={'tile-subcopy ' + htmlWidget + ((props.slides.eirRtceTile.length === 3 || props.slides.eirRtceTile.length === 2) ? 'three-tile-rtce-copy' : 'rtce-copy')} dangerouslySetInnerHTML={renderContent(tile.tileSubcopy)}></div>
                                }
                            </div>
                        }
                        {/* title's bottom cta */}
                        {
                            tile.tileCTA != undefined &&
                            <div className='d-flex justify-content-center align-items-center mb-3 rtce-tile-cta'>
                                {/* <EirButton databundlecode={"rtce_btn_" + (i + 1)} className={(tile.tileCTA.type !== 'link' ? (css`border-color: ${tile.OutlineColorCTA}; &:hover, &:focus, &:focus-within, &:active {background: ${tile.OutlineColorCTA} !important;border-color: ${tile.OutlineColorCTA} !important}`) : 'link-cta') + ' js-prequal-modal-btn eir-text-secondary ls-0 p-2 cta_threesix'} {...tile.tileCTA} /> */}
                                {tile.tileCTA.outline ?
                                <EirButton ariaLabel={tile.tileCTA.ariaLabel} databundlecode={"rtce_btn_" + (i + 1)} useInlineCSS={( tile.BackgroundColorCTA !=='' )?true:false} className={(tile.tileCTA.type !== 'link' ? (css`background: ${tile.BackgroundColorCTA} !important; border-color: ${tile.OutlineColorCTA} !important; color: ${tile.FontColorCTA} !important; &:hover, &:focus, &:focus-within, &:active {background: ${tile.BackgroundColorHoverCTA} !important;border-color: ${tile.OutlineColorHoverCTA}  !important; color: ${tile.FontColorHoverCTA} !important}`) : 'link-cta') + ' js-prequal-modal-btn eir-text-secondary ls-0 p-2 reasonToChooseCTA cta_threesix'} {...tile.tileCTA} />
                                : <EirButton ariaLabel={tile.tileCTA.ariaLabel} databundlecode={"rtce_btn_" + (i + 1)} useInlineCSS={(tile.BackgroundColorCTA !=='' )?true:false} className={(tile.tileCTA.type !== 'link' ? (css`background: ${tile.BackgroundColorCTA} !important; border-color: ${tile.BackgroundColorCTA} !important; color: ${tile.FontColorCTA} !important; &:hover, &:focus, &:focus-within, &:active {background: ${tile.BackgroundColorHoverCTA} !important;border-color: ${tile.BackgroundColorHoverCTA}  !important; color: ${tile.FontColorHoverCTA} !important}`) : 'link-cta') + ' js-prequal-modal-btn eir-text-secondary ls-0 p-2 reasonToChooseCTA cta_threesix'} {...tile.tileCTA} />
                                }
                               </div>
                        }
                    </div>
                </div>
            }
        </div>
    );

    const mobileSlides = props.slides.eirRtceTile.map((tile, i) =>
        <div key={i} className='tiles-main'>
            {
                <div className="rtce-tiles-mobile" onClick={() => console.log("a tile is clicked from mobile")}>
                    <div className={'d-flex flex-column justify-content-center tile-inner-mobile'}>
                        <div className='rtce-tile-image d-flex justify-content-center align-items-center' style={(tile.tileCTA != undefined || tile.tileTitle == '') ? { marginBottom: "15px" } : {}}>
                            {tile.tileImage.path !== undefined && (tile.tileImage.path.indexOf(".svg") > 0 ?
                                <object className='w-100 h-auto tile-image' data={tile.tileImage.path} type={"image/svg+xml"} />
                                :
                                <img className='w-100 h-auto tile-image' src={tile.tileImage.path} alt={tile.altText} />
                            )}
                        </div>
                        {(tile.tileTitle !== '') &&
                            <div className={'rtce-tile-copy-mobile w-100'}>
                                <div className={'title-mobile ' + htmlWidget} dangerouslySetInnerHTML={renderContent(tile.tileTitleMobile)}></div>
                                {tile.tileSubtitle !== '' &&
                                    <div className={'subtitle-mobile' + htmlWidget} dangerouslySetInnerHTML={renderContent(tile.tileSubTitleMobile)}></div>
                                }
                                {tile.tileSubcopy !== '' &&
                                    <div className={'subcopy-mobile' + htmlWidget} dangerouslySetInnerHTML={renderContent(tile.tileSubCopyMobile)}></div>
                                }
                            </div>
                        }
                        {
                            tile.tileCTA &&
                            <div className='d-flex justify-content-center align-items-center mb-3'>
                                {/* <EirButton databundlecode={"rtce_btn_" + (i + 1)} className={css`border-color: ${tile.OutlineColorCTA}; &:hover, &:focus, &:focus-within, &:active {background: ${tile.OutlineColorCTA} !important;border-color: ${tile.OutlineColorCTA} !important}` + ' js-prequal-modal-btn eir-text-secondary ls-0 p-2 cta_threesix'} {...tile.tileCTA} /> */}
                                {tile.tileCTA.outline ?
                                <EirButton ariaLabel={tile.tileCTA.ariaLabel} databundlecode={"rtce_btn_" + (i + 1)} useInlineCSS={(tile.BackgroundColorCTA !=='' )?true:false} className={css`background: ${tile.BackgroundColorCTA} !important; border-color: ${tile.OutlineColorCTA} !important; color: ${tile.FontColorCTA} !important; &:hover, &:focus, &:focus-within, &:active {background: ${tile.BackgroundColorHoverCTA}  !important;border-color: ${tile.OutlineColorHoverCTA} !important; color: ${tile.FontColorHoverCTA} !important}` + ' js-prequal-modal-btn eir-text-secondary ls-0 p-2 reasonToChooseCTA cta_threesix'} {...tile.tileCTA} />
                                : <EirButton ariaLabel={tile.tileCTA.ariaLabel} databundlecode={"rtce_btn_" + (i + 1)} useInlineCSS={(tile.BackgroundColorCTA !=='' )?true:false} className={css`background: ${tile.BackgroundColorCTA} !important; border-color: ${tile.BackgroundColorCTA} !important; color: ${tile.FontColorCTA} !important; &:hover, &:focus, &:focus-within, &:active {background: ${tile.BackgroundColorHoverCTA}  !important;border-color: ${tile.BackgroundColorHoverCTA} !important; color: ${tile.FontColorHoverCTA} !important}` + ' js-prequal-modal-btn eir-text-secondary ls-0 p-2 reasonToChooseCTA cta_threesix'} {...tile.tileCTA} />
                                }
                            </div>
                        }
                    </div>
                </div>
            }
        </div>
    );
    return (
        <Fragment>
            {(!isMobile) &&
                <div className='rtce-slides'>
                    {props.slides.eirRtceTile.length > 4 ?          
                        <div
                        onFocusCapture={() => sliderRef.current && sliderRef.current.slickPause()}
                        onBlurCapture={(e) => {
                            const leftCompletely = !e.currentTarget.contains(e.relatedTarget);
                            if (leftCompletely && !userPausedRef.current) {
                                sliderRef.current.slickPlay();
                                sliderRef.current.innerSlider.autoplay = true;               
                            }                        
                        }}
                        >
                        <Slider ref={sliderRef} {...settingsModules} className="pt-4 d-flex justify-content-center">
                            {slides}
                        </Slider>
                        </div>
                        :
                        LargeBusiness.isLBSite ?
                            <Slider {...settingsModules} className="pt-4 d-flex justify-content-center">
                                {slides}
                            </Slider> :
                            <div className='pt-4 d-flex justify-content-center'>
                                {slides}
                            </div>
                    }
                </div>
            }

            {isMobile && !isTablet &&
                <div className='rtce-slides-mobile'>
                    <div
                        onFocusCapture={() => sliderRef.current && sliderRef.current.slickPause()}
                        onBlurCapture={(e) => {
                            const leftCompletely = !e.currentTarget.contains(e.relatedTarget);
                            if (leftCompletely && !userPausedRef.current) {
                                sliderRef.current.slickPlay();
                                sliderRef.current.innerSlider.autoplay = true;      
                            }                        
                        }}
                        >
                    <Slider ref={sliderRef} {...mobileSettingsModules} className={copy + " mobile-tile"}>
                        {mobileSlides}
                    </Slider>
                    </div>
                </div>
            }

            {(isMobile && isTablet) &&
                <div className='rtce-slides'>
                    <div
                        onFocusCapture={() => sliderRef.current && sliderRef.current.slickPause()}
                        onBlurCapture={(e) => {
                            const leftCompletely = !e.currentTarget.contains(e.relatedTarget);
                            if (leftCompletely && !userPausedRef.current) {
                                sliderRef.current.slickPlay();
                                sliderRef.current.innerSlider.autoplay = true;      
                            }                        
                        }}
                        >
                    <Slider ref={sliderRef} {...tabletSettingsModules}>
                        {slides}
                    </Slider>
                    </div>
                </div>
            }

        </Fragment>
    )
}

export default RtceSlides
